'use strict';

var paragraphRichText = paragraphRichText || {};
var $ = jQuery;

/* INIT
 ----------------------------------------------------------------------------------------------------------------------*/
paragraphRichText.init = function () {
  paragraphRichText.tableWrapper();
}

/* DOM READY
 ----------------------------------------------------------------------------------------------------------------------*/
$(paragraphRichText.init);

/* FUNCTIONS
 ----------------------------------------------------------------------------------------------------------------------*/
// Add wrapper responsive around tables
paragraphRichText.tableWrapper = function () {

  // console.log('paragraph rich text');

  var paragraph = $('.paragraph--type--rich-text');
  var table = paragraph.find('table');

  table.addClass('table');
  table.wrap( "<div class='table-responsive'></div>" );

};